import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Filter, { FilterModel } from '../../components/Filter/Filter';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import { upsertFilterToKey } from '../../services/filterService';
import CustomSelect from '../../components/CustomSelect/CustomSelect';
import { entityActions } from '../../enums/AuditLogActionEnum';

type UserModel = {
  id: number;
  role: string;
  name: string;
  email: string;
};

export class AuditLogFilterFields extends FilterModel {
  user?: number | null;
  action: string;

  constructor(data: any = {}) {
    super(data);
    this.user = data.user;
    this.action = data.action;
  }

  public get totalFilters(): number {
    let total = 0;
    if (this.user) total += 1;
    if (this.action) total += 1;
    if (this.q) total += 1;
    return total;
  }
}

interface AuditLogsFilterProps {
  onSubmit: (data: AuditLogFilterFields) => void;
  filterFields: AuditLogFilterFields;
  pageKey: string;
}

export default function AuditLogsFilter({
  onSubmit,
  filterFields,
  pageKey,
}: AuditLogsFilterProps) {
  const { control, register, handleSubmit, reset, setValue } =
    useForm<AuditLogFilterFields>({
      mode: 'onBlur',
    });
  const {
    isAdmin,
    user: { organization },
  } = useAuth();

  const [users, setUsers] = useState<UserModel[]>([]);
  const [usersLoading, setUsersLoading] = useState(false);

  async function getUsers() {
    if (organization && isAdmin) {
      setUsersLoading(true);
      const { data } = await api.get(
        `admin/organizations/${organization.id}/users`
      );
      setUsers(data.data);
      setUsersLoading(false);
    }
  }

  const clear = () => {
    reset({
      user: null,
      q: null,
      skip: 0,
      take: 25,
    });
    upsertFilterToKey(pageKey, {});
  };

  useEffect(() => {
    reset(filterFields);
  }, [filterFields]);

  useEffect(() => {
    getUsers();
  }, [organization, isAdmin]);

  return (
    <Filter
      isLoading={usersLoading}
      onSubmit={handleSubmit(onSubmit)}
      clear={clear}
      totalApplied={filterFields?.totalFilters || 0}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='mb-3'>
          <input
            {...register('q')}
            className='form-control'
            placeholder='Digite para pesquisar'
            type='text'
          />
        </div>
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className='form-label'>Usuário</label>
          <Controller
            name='user'
            control={control}
            render={({ field }) => (
              <CustomSelect
                options={users.map((user: any) => ({
                  label: user.name,
                  value: user.id,
                }))}
                value={field.value ?? ''}
                onChange={field.onChange}
                placeholder='Selecione o Usuário'
              />
            )}
          />
        </div>
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Status
          </label>
          <select
            required
            className='form-select'
            aria-label='Selecione o equipamento'
            {...register('action', { required: false })}
          >
            <option value=''>Selecione a Ação</option>
            {entityActions.map((entity) => (
              <option value={entity.action} key={entity.action}>
                {entity.name}
              </option>
            ))}
          </select>
        </div>
      </form>
    </Filter>
  );
}
